import { useEffect } from "react";
import { useViolation } from "./ViolationContext";

export default function FullScreenGuard() {
  const { registerViolation } = useViolation();

  useEffect(() => {
    const handleExit = () => {
      if (!document.fullscreenElement) {
        registerViolation("Exited fullscreen");
      }
    };

    document.addEventListener("fullscreenchange", handleExit);
    return () =>
      document.removeEventListener("fullscreenchange", handleExit);
  }, []);

  return null;
}
